// ============================================================
// TASK FACTORY
//
// Builds a BluPrint Task from an approved Occurrence.
//
// The Task Factory should never evaluate recurrence rules.
// It simply manufactures a task.
// ============================================================

export function buildTaskFromOccurrence(occurrence) {

  const { template, dueDate } = occurrence

  console.log("🏭 TASK FACTORY TEMPLATE:", {
    id: template?.id,
    name: template?.name,
    focus_area_id: template?.focus_area_id,
    project_id: template?.project_id,
    context_id: template?.context_id,
    location_id: template?.location_id,
    persistence_type: template?.persistence_type,
    day_type_id: template?.day_type_id
  })

  return {

    // --------------------------------------------------
    // Core
    // --------------------------------------------------
    name: template.name,
    notes: template.notes || '',

    // --------------------------------------------------
    // Scheduling
    // --------------------------------------------------
    due_date: dueDate,

    // --------------------------------------------------
    // Status
    // --------------------------------------------------
    status_id: template.status_id || 1,

    // --------------------------------------------------
    // Relationships
    // --------------------------------------------------
    project_id: template.project_id ?? null,
    priority_id: template.priority_id ?? null,
    task_time_id: template.task_time_id ?? null,
    context_id: template.context_id ?? null,
    focus_area_id: template.focus_area_id ?? null,
    location_id: template.location_id ?? null,

    // --------------------------------------------------
    // Metadata
    // --------------------------------------------------
    time_of_day_id: template.time_of_day_id ?? null,
    impact_id: template.impact_id ?? null,
    capacity_id: template.capacity_id ?? null,
    day_type_id: template.day_type_id ?? null,
    persistence_type: template.persistence_type ?? null,

    // --------------------------------------------------
    // Recurring Link
    // --------------------------------------------------
    recurring_task_id: template.id,

    // --------------------------------------------------
    // Ownership
    // --------------------------------------------------
    user_id: template.user_id,

    // --------------------------------------------------
    // Default State
    // --------------------------------------------------
    is_completed: false,

    created_at: new Date().toISOString()

  }

}